<template>
  <div class="detail-page">
    <div class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <div class="form-content-img">
          <img
            v-if="userDetail.profile_photo"
            :src="userDetail.profile_photo"
            alt=""
          />
          <img v-else src="../../../../../static/image/no-img.png" alt="" />
        </div>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="half">
            <h4>用户ID</h4>
            <span>{{ userDetail.user_id }}</span>
          </li>
           <li class="half">
            <h4>用户名</h4>
            <span>{{ userDetail.username }}</span>
          </li>
          <li class="half">
            <h4>手机</h4>
            <span>{{ userDetail.phone }}</span>
          </li>
          <li class="half">
            <h4>邮箱</h4>
            <span>{{ userDetail.email }}</span>
          </li>
           <li class="one-third">
            <h4>姓</h4>
            <span>{{ userDetail.last_name }}</span>
          </li>
           <li class="one-third">
            <h4>名</h4>
            <span>{{ userDetail.first_name }}</span>
          </li>
          <li class="one-third">
            <h4>位置</h4>
            <span>{{ userDetail.loaction }}</span>
          </li>
          <li class="one-third">
            <h4>性别</h4>
            <span>{{ userDetail.gender==1?"男":userDetail.gender==2?'女':"" }}</span>
          </li>
           <li class="one-third">
            <h4>生日</h4>
            <span>{{ userDetail.birthday }}</span>
          </li>
           <li class="one-third">
            <h4>职业状态</h4>
            <span>{{  userDetail.occupation_status==1?"工作人员":userDetail.occupation_status==2?'在校学生':"" }}</span>
          </li>
           <li class="one-third">
            <h4>公司</h4>
            <span>{{  userDetail.company}}</span>
          </li>
           <li class="one-third">
            <h4>职业</h4>
            <span>{{  userDetail.occupation}}</span>
          </li>
            <li class="one-third">
            <h4>大学</h4>
            <span>{{  userDetail.university}}</span>
          </li>
           <li class="one-third">
            <h4>专业</h4>
            <span>{{  userDetail.professional}}</span>
          </li>
           <li class="one-third">
            <h4>入学时间</h4>
            <span>{{ userDetail.enroll}}</span>
          </li>
          <li class="one-third">
            <h4>用户类型</h4>
            <span>{{ userDetail.group==2?"普通用户":"非普通用户" }}</span>
          </li>
          
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["userDetail"],
};
</script>

<style scoped lang="scss">
.form-content-img{
   height:200px !important;
    width:200px !important;
  img{

    border-radius: 50%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/userManagement/userDetail/UserBasisInfo.vue